import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.333 1.333h9.334a2 2 0 0 1 2 2V14a.67.67 0 0 1-.414.613.666.666 0 0 1-.727-.14L11.06 12H3.333a2 2 0 0 1-2-2V3.333a2 2 0 0 1 2-2m6.963 4.78a.667.667 0 1 1 .74 1.108.667.667 0 0 1-.74-1.109M8 6a.667.667 0 1 0 0 1.333A.667.667 0 0 0 8 6m-3.037.112a.667.667 0 1 1 .74 1.109.667.667 0 0 1-.74-1.109",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })